module.exports = __webpack_public_path__ + "static/media/icon_94.fc44e4dd.svg";